import { useMemo } from 'react';
import { UserRoleEnum } from '../types';
import { useUser } from './useUser';

export const useRolesPermissions = (permissions: UserRoleEnum[]): boolean => {
  const [user] = useUser();
  
  // Memoize the result to prevent unnecessary re-renders
  return useMemo(() => {
    if (!user || !user.role) return false;
    let userRole = user.role;
    return permissions.includes(userRole as UserRoleEnum);
  }, [user?.role, permissions]);
}
